export default __webpack_public_path__ + "static/media/erco.fd020ab6.png";